import React, { memo, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2'
import CloseIcon from 'components/icons/CloseIcon.svg'
import TrashIcon from 'components/icons/TrashIcon.svg'
import FiltersIcon from 'components/icons/FiltersIcon.svg'
import { Button, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { applyThousandSeparator } from 'react-number-format/lib/utils'
import { getItemText, validFinACarKeys } from 'utils/filters'
import pickBy from 'lodash/pickBy'
import capitalize from 'lodash/capitalize'
import clsx from 'clsx'
import sx from './styles'

const maxPrice = '$1,450,000'

const formatCarDataDynamic = (data = {}) => {
  const dataTemp = { ...data }
  const min = dataTemp?.min ? applyThousandSeparator(`$${dataTemp?.min || 0}`, ',') : null
  const max = dataTemp?.max ? applyThousandSeparator(`$${dataTemp?.max || 0}`, ',') : null

  if (min && max) {
    if (max === maxPrice) {
      dataTemp.price = `De ${min} a $+600,000`
    } else {
      dataTemp.price = `De ${min} a ${max}`
    }
  }

  if (data?.body) {
    dataTemp.body = `${data?.body}`
      .replace(/desconocido|mm|familiar \(es\)/g, '') // Elimina palabras específicas
      .replace(/_{2,}/g, '_') // Reemplaza múltiples guiones bajos consecutivos por uno
      .replace(/^_|_$/g, '') // Elimina guiones bajos al inicio o al final
      .trim() // Elimina espacios en blanco al inicio y final
  }

  delete dataTemp?.min
  delete dataTemp?.max

  const summaryText = Object.entries(pickBy(dataTemp))
    .filter(([key]) => validFinACarKeys?.includes(key))
    .map(([key, value]) => getItemText(key, value))
    .join(', ')

  return summaryText
}

const SummaryFilter = ({
  showAllFilters,
  toggleShowAllFilters,
  onResetFindACarFilters,
}) => {
  const { findACar } = useSelector((s) => s.search)
  const [summaryText, setSummaryText] = useState('')

  const handleClearAllFilters = () => {
    onResetFindACarFilters()
  }

  const handleToggleShowFilter = () => {
    toggleShowAllFilters()
  }

  useEffect(() => {
    setSummaryText(capitalize(formatCarDataDynamic(findACar)))
  }, [findACar])

  return (
    <Grid
      container
      sx={sx.root}
      gap={1}
    >
      <Grid
        size="grow"
        sx={sx.summaryTextContainer}
      >
        <Typography
          variant="strong"
          sx={sx.summary}
        >
          {summaryText}
        </Typography>
      </Grid>
      <Grid
        size="auto"
        sx={{ ...sx.iconContainer, ...sx.trashContainer }}
      >
        <Button
          aria-label="delete"
          size="small"
          variant="text"
          fullWidth
          onClick={handleClearAllFilters}
        >
          <TrashIcon fontSize="inherit" />
        </Button>
      </Grid>
      <Grid
        size="auto"
        sx={{ ...sx.iconContainer, ...sx.openCloseContainer }}
        className={clsx({
          delete: showAllFilters,
        })}
      >
        <Button
          aria-label="delete"
          size="small"
          variant="text"
          fullWidth
          onClick={handleToggleShowFilter}
        >
          {showAllFilters ? <CloseIcon /> : <FiltersIcon />}
        </Button>
      </Grid>
    </Grid>
  )
}

export default memo(SummaryFilter)
